import React from 'react';
import { useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';
import { useDialogState } from 'modules/common/hooks';

type TimeSignalActionProp = {
  testId: string;
  onClick: () => void;
  title: string;
  loading: boolean;
  className: string;
  icon: React.ReactElement;
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
  classes?: ClassNameMap;
  disabled?: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {},
  disabled: {
    color: theme.palette.grey[100]
  }
}));
export const TimeSignalAction: React.FC<TimeSignalActionProp> = ({
  testId,
  title,
  onClick,
  loading,
  className,
  icon,
  color = 'primary',
  classes: overrideClasses,
  disabled
}: TimeSignalActionProp) => {
  const { open, closeDialog, openDialog } = useDialogState();
  const handleClick = useCallback(() => {
    closeDialog();
    setTimeout(onClick, 100);
  }, [closeDialog, onClick]);
  const classes = useStyles({ classes: overrideClasses });
  return (
    <Tooltip
      open={open}
      title={title}
      onClose={closeDialog}
      onOpen={openDialog}
    >
      <IconButton
        data-testid={testId}
        color={color}
        onClick={handleClick}
        disabled={disabled || loading}
        className={className}
        classes={classes}
        size="large"
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};
